<!--
  Scorciatoia per registrare un cliente che non c'e' ancora.
-->
<template>
  <div class="nuovo-cliente">
    <span class="nuovo-cliente__testo">
      Il cliente è nuovo? Registralo qui prima di prenotare.
    </span>
    <router-link
      class="routerLink"
      :to="destinazione"
    >
      <el-button
        size="small"
        type="primary"
        plain
      >
        <el-icon :size="15">
          <CirclePlus />
        </el-icon>
        <span class="nuovo-cliente__label">Nuovo cliente</span>
      </el-button>
    </router-link>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { rottaNuovoCliente } from '../services/servizi.js';

export default {
  name: 'AddNewCustomerComponent',
  props: {
    // Il servizio del form che ospita il pulsante: a cliente creato si torna li'.
    servizio: { type: String, default: '' },
  },
  setup(props) {
    const route = useRoute();
    const destinazione = computed(() => rottaNuovoCliente(props.servizio, route.query.data));
    return { destinazione };
  },
};
</script>

<style scoped>
.nuovo-cliente {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  text-align: left;
}

.nuovo-cliente__testo {
  font-size: 13px;
  color: var(--color-text-secondary, #737373);
}

.nuovo-cliente__label {
  margin-left: 6px;
}
</style>
